// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3LVUE","colMin":"styles_colMin__1P1qy","colCheckbox":"styles_colCheckbox__EQGjG"};